export enum RequestOperationType {
  IsLoading = "isLoading",
  IsSaving = "isSaving",
  IsDeleting = "isDeleting",
  IsCloning = "isCloning",
  DeletingById = "deletingId",
  None = "none",
}
